import { UserPermission } from 'constants/userPermission';
import { Icon } from '@kontentino/ui';
import { faUserPlus } from '@fortawesome/pro-regular-svg-icons/faUserPlus';
import PermissionsGateButton from 'app/components/PermissionsGateButton';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
type Props = {
  onClick: () => void;
  reassign?: boolean;
};

const AssignTaskWorkflowButton: FC<Props> = ({ onClick, reassign }) => {
  const { t } = useTranslation();

  return (
    <PermissionsGateButton
      scopes={[UserPermission.USER_ASSIGN_TASK]}
      variant="secondary"
      iconBefore={<Icon icon={faUserPlus} />}
      onClick={onClick}
      data-cy="post-assign-task-button"
    >
      {reassign ? t('reassignTask') : t('assignTask')}
    </PermissionsGateButton>
  );
};

export default AssignTaskWorkflowButton;
